<template>
  <div class="coach-select-box">
    <div v-for="(list, index) in coachSelectVOForm" :key="index" class="flex" style="margin-bottom: 10px;">
      <el-select
        v-model="coachSelectVOForm[index].level"
        placeholder="请选择教练级别"
        style="margin-right: 20px"
        @change="handleCoachSelectChange(index)"
      >
        <el-option
          v-for="item in coachLevels"
          :key="item.level"
          :label="item.level"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="coachSelectVOForm[index].id"
        placeholder="请选择教练名称"
        @change="coachSelectChange"
      >
        <el-option
          v-for="it in coachSelectVO[coachSelectVOForm[index].level]"
          :key="it.id"
          :label="it.firstName + it.lastName"
          :value="it.id"
        />
      </el-select>
      <template v-if="coachSelectVOForm.length===1">
        <div class="btn-reset" @click="handleReset">重置</div>
      </template>
      <div
        v-if="index !== 0 && coachSelectVOForm[index].level"
        class="form-icon"
        @click="handleRemoveCoach(index)"
      >
        <el-icon class="el-icon-close" />
      </div>
    </div>
    <div class="form-add">
      <el-button icon="el-icon-plus" @click="handleAddCoach">添加活动教练</el-button>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      coachSelectVOForm: [{
        id: "",
        level: "",
        firstName: "",
        lastName: "",
        time: Date.parse(new Date()),
      }],
      coachSelectVOList: [],
    };
  },
  computed: {
    coachSelectVO() {
      return this.$store.state.activity.coachSelectVO.reduce((pre, current) => {
        if (!pre[current.level]) {
          pre[current.level] = [];
        }
        pre[current.level].push(current);
        return pre;
      }, {});
    },
    coachLevels() {
      return this.$store.state.activity.coachLevels || [];
    },
    coachSelectList() {
      return this.$store.state.activity.coachSelectVO.reduce((pre, current) => {
        if (pre.findIndex(item => item.level === current.level) === -1) {
          pre.push(current);
        }
        return pre;
      }, []);
    },
    ids() {
      return this.coachSelectVOForm.map(item => item.id);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val && val.length) {
          this.coachSelectVOForm = [].concat(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleChange() {
    },
    handleReset() {
      this.coachSelectVOForm = [{
        id: "",
        level: "",
        firstName: "",
        lastName: "",
        time: Date.parse(new Date()),
      }];
      this.$emit('change', this.coachSelectVOForm);
    },
    handleRemoveCoach(index) {
      this.coachSelectVOForm.splice(index, 1);
      this.$emit('change', this.coachSelectVOForm);
      this.$parent.$emit("el.form.change");
    },
    handleAddCoach() {
      this.coachSelectVOForm.push({
        id: "",
        level: "",
        firstName: "",
        lastName: "",
        time: Date.parse(new Date()),
      });
      this.$emit('change', this.coachSelectVOForm);
    },
    coachSelectChange(id) {
      this.$emit('change', this.coachSelectVOForm);
    },
    handleCoachSelectChange(index) {
      this.coachSelectVOForm.forEach((item, i) => {
        if (i === index) {
          item.id = '';
        }
      });
      this.$emit('change', this.coachSelectVOForm);
    },
  },
};
</script>

<style></style>
